
import ASSETS from '@generio-ai/library-legacy/constants/assets'
import { File } from '@generio-ai/library-legacy/stores/_api'
import { Task } from '@/classes/task.js'


export default {

    // create primitive asset
    // TODO only short cut of commitCreateAssets; remove duplication
    async commitPrimitiveAsset({ dispatch, getters }) {
        return new Task(
            async (resolve, reject, progress, app, card) => {
                try {
                    // inform user about status
                    progress('preparing card')

                    // flag primitive
                    card.primitive = true

                    // get parent card
                    const parentCard = getters.getParentCard(app, card)

                    // prepare additional
                    const additional = card.createAdditional(parentCard)

                    // get parent assets (or selected, if exists)
                    let parentAssets = parentCard?.assets || []
                    const selectedParentAsset = parentCard.getSelectedAsset()
                    if (selectedParentAsset) parentAssets = [selectedParentAsset]

                    // clone all assets
                    const response = await Promise.all(parentAssets.map(asset =>
                        dispatch('assets/create', {
                            app,
                            additional
                        }, { root: true })
                    ))

                    // collect created assets from response
                    const createdAssets = response.map(response => response.assets[0])

                    // resolved successfully
                    resolve({ assets: createdAssets })

                }
                catch (error) {
                    // reject with error
                    reject(error)
                }
            }
        )
    },

    // create files asset
    async commitFilesAsset({ dispatch, getters }, {
        files = null,
        thumbnail = null,
        preload = false
    } = {}) {
        return new Task(
            async (resolve, reject, progress, app, card) => {
                try {
                    // inform user about status
                    progress('preparing card')

                    // get parent card
                    const parentCard = getters.getParentCard(app, card)

                    // prepare additional
                    const additional = card.createAdditional(parentCard)

                    // create asset
                    const response = await dispatch('assets/create', {
                        app,
                        files,
                        thumbnail: thumbnail ? false : true, // set automatic rendering to false if thumbnail is provided
                        additional
                    }, { root: true })

                    // get created asset
                    const createdAssets = response?.assets

                    // patch thumbnail if provided
                    if (thumbnail) {
                        await dispatch('assets/updateThumbnail', {
                            asset: createdAssets[0],
                            data: thumbnail
                        }, { root: true })
                    }

                    // if assets should be preloaded
                    if (preload) {
                        await dispatch("awaitRetrieved", {
                            assets: createdAssets
                        })
                    }

                    // resolved successfully
                    resolve({ assets: createdAssets })
                }
                catch (error) {
                    // reject with error
                    reject(error)
                }
            }
        )
    },

    // creates asset(s); multiple when fileData an array
    async commitCreateAssets({ dispatch, getters }, {
        fileData = null,
        fileParameters = null,
        preload = false
    } = {}) {
        return new Task(
            async (resolve, reject, progress, app, card) => {

                try {
                    // inform user about status
                    progress('preparing card')

                    // collecting all created assets
                    const createdAssets = []

                    // get parent card
                    const parentCard = getters.getParentCard(app, card)

                    // prepare additional
                    const additional = card.createAdditional(parentCard)

                    // ensure fileData is an array
                    const fileDataArray = Array.isArray(fileData) ? fileData : [fileData]

                    // iterate through all fileData
                    for (const fileData of fileDataArray) {

                        // prepare file
                        const files = fileData ? [new File(ASSETS.FILES.KEY.DEFAULT, fileData, null, fileParameters)] : null

                        // create asset
                        const response = await dispatch('assets/create', {
                            app,
                            files: files,
                            additional
                        }, { root: true })

                        // add asset to list
                        createdAssets.push(response.assets[0])
                    }

                    // if assets should be preloaded
                    if (preload) {
                        await dispatch("awaitRetrieved", {
                            assets: createdAssets
                        })
                    }

                    // resolved successfully
                    resolve({ assets: createdAssets })

                } catch (error) {
                    // reject with error
                    reject(error)
                }
            }
        )
    },
    // update assets additional data
    async commitUpdateAssets({ dispatch, getters }, {
        skipped = false
    } = {}) {
        return new Task(
            async (resolve, reject, progress, app, card) => {
                try {
                    // inform user about status
                    progress('preparing card')

                    // get parent card
                    const parentCard = getters.getParentCard(app, card)

                    // prepare additional
                    const additional = card.createAdditional(parentCard)

                    // update card skipped state
                    card.skipped = skipped

                    // update all assets
                    await Promise.all(card.assets.map(asset => {
                            const assetAdditional = { ...additional }
                            const perspective = asset?.additional?.perspective || null
                            assetAdditional.perspective = perspective
                            dispatch('assets/updateAdditional', {
                                asset: asset,
                                additional: assetAdditional
                            }, { root: true })
                        }
                    ))

                    // resolved successfully
                    resolve({ assets: card.assets })

                } catch (error) {
                    // reject with error
                    reject(error)
                }
            }
        )
    }
}